module.exports = __webpack_public_path__ + "img/1-on.7af37eec.png";